import { Node } from '@tiptap/core';

export const HtmlElements = Node.create({
  name: 'htmlElements',
  group: 'block',
  content: 'block+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute('class'),
        renderHTML: (attributes) => {
          if (!attributes.class) {
            return {};
          }
          return {
            class: attributes.class,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'section',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'article',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'aside',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'main',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 0];
  },
});
